"use client"

import Link from "next/link"
import { Mail, Phone, MapPin } from "lucide-react"

export function Footer() {
  return (
    <footer className="bg-foreground text-background mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="font-bold text-lg mb-4">Let me be a child</h3>
            <p className="text-sm opacity-90">Children&apos;s aid for street children and orphans in Ethiopia.</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link href="/about" className="opacity-90 hover:opacity-100 transition-opacity">
                  About Us
                </Link>
              </li>
              <li>
                <Link href="/team" className="opacity-90 hover:opacity-100 transition-opacity">
                  Our Team
                </Link>
              </li>
              <li>
                <Link href="/blog" className="opacity-90 hover:opacity-100 transition-opacity">
                  Blog
                </Link>
              </li>
              <li>
                <Link href="/news" className="opacity-90 hover:opacity-100 transition-opacity">
                  News
                </Link>
              </li>
              <li>
                <Link href="/contact" className="opacity-90 hover:opacity-100 transition-opacity">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h4 className="font-semibold mb-4">Get Involved</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link href="/become-member" className="opacity-90 hover:opacity-100 transition-opacity">
                  Become a Member
                </Link>
              </li>
              <li>
                <Link href="/become-sponsor" className="opacity-90 hover:opacity-100 transition-opacity">
                  Become a Sponsor
                </Link>
              </li>
              <li>
                <Link href="/gallery" className="opacity-90 hover:opacity-100 transition-opacity">
                  Gallery
                </Link>
              </li>
              <li>
                <Link href="/sponsors" className="opacity-90 hover:opacity-100 transition-opacity">
                  Our Sponsors
                </Link>
              </li>
              <li>
                <Link href="/donate" className="opacity-90 hover:opacity-100 transition-opacity">
                  Donate
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-2">
                <MapPin size={16} className="flex-shrink-0 mt-0.5" />
                <span className="opacity-90">Bäckerkoppel 10a, D-24977 Langballig</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={16} />
                <a href="tel:+4946369766-30" className="opacity-90 hover:opacity-100">
                  +49 4636 97 66 30
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Mail size={16} />
                <a href="mailto:kontakt@let-me-be-a-child.de" className="opacity-90 hover:opacity-100">
                  kontakt@let-me-be-a-child.de
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm opacity-90">© 2025 Let me be a child e.V. All rights reserved.</p>
          <div className="flex gap-4 text-sm mt-4 md:mt-0">
            <Link href="/privacy" className="opacity-90 hover:opacity-100">
              Privacy Policy
            </Link>
            <Link href="/imprint" className="opacity-90 hover:opacity-100">
              Imprint
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
